module.exports = __webpack_public_path__ + "img/math.ac3e8024.png";